export default __webpack_public_path__ + "static/audit_scanner-445a8789140ffb8fcd8178f6f09fc00b.png";